import { render, staticRenderFns } from "./PropertyEditorContainer.vue?vue&type=template&id=1b82690e&"
import script from "./PropertyEditorContainer.vue?vue&type=script&lang=js&"
export * from "./PropertyEditorContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b82690e')) {
      api.createRecord('1b82690e', component.options)
    } else {
      api.reload('1b82690e', component.options)
    }
    module.hot.accept("./PropertyEditorContainer.vue?vue&type=template&id=1b82690e&", function () {
      api.rerender('1b82690e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/components/PropertyEditorContainer.vue"
export default component.exports